import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import GjsEditor, { Canvas } from "@grapesjs/react";
import gjsBlockBasic from "grapesjs-blocks-basic";
import gjsForms from "grapesjs-plugin-forms";
// import gjsTabs from "grapesjs-tabs";
import gjsCssParser from "grapesjs-parser-postcss";
import grapesjsStyleBg from "grapesjs-style-bg";
import gjsImageEditor from "grapesjs-tui-image-editor";
import "grapesjs-rulers/dist/grapesjs-rulers.min.css";
import gjsRulers from "grapesjs-rulers";
import gjsStyleGradient from "grapesjs-style-gradient";

import { WithEditor } from "@grapesjs/react";
import AiAssistantWithEditor from "../AiAssistantPopup/AiAssistantWithEditor";

import ToastAlert from "../ToastAlert/ToastAlert.jsx";
import { LeftSidebar, RightSidebar } from "../Sidebar.js";
import TopNav from "../TopNav.js";

import { updateFontFamily } from "../../helpers/customFont.js";
import swiperComponent from "../../plugins/swiper";
import {
  addEditorCommand,
  layerManager,
  scripts,
  selectorManager,
  styleManager,
  styles,
  traitManager,
  addTemplates,
  addHeaders,
  addHR,
  uploadAssets,
  customComponents,
  grapesJsStyleBGPluginOpts,
  dataListTypePlugin,
  addDeviceManagerPanels,
  // addModalTriggerElement,
  addPosterTrait,
  addPseudoSelectors,
  addSelectRemoveStyleOption,
  addVeevaExternalLink,
  addVAEemail,
  addWrapperBlock,
  closeAssetManagerOnAssetSelect,
  enableDraggingFormElements,
  handleAssetDelete,
  makeRowsCellsResizable,
  openVideoManagerOnAddingVideo,
  preserveComponentNames,
  // preserveComponentTypes,
  richTextEditor,
  loadAssetsFromDB,
  showAlertOnError,
  handleHamburgerClick,
  previewHandler,
  closeAllCategoriesByDefault,
  storageSetting,
  removeBackgroundInputForBody,
  getExternalStyles,
  showUnsavedChangesNum,
  addDocLink,
  // addAdaptiveScript,
  autoCloseCategories,
  toggleAbsoluteDragMode,
  moveComponentsByKeys,
  addDiv,
  linkAdjust,
  Resize,
  removeGjsSelectedClass,
  hideToolbarOnStyleClick,
  avoidMultipleWrapper,
  addComponents,
  addComponentModel,
  addNthchildSelector,
  addMCTSJs,
  removeTextDefaultPadding,
  addCustomVeevaLink,
  bootstrapDefaultStyles,
  addTabComponent,
  addCarouselComponent,
  addIScroll,
  addMultiCarousel,
  addPlaceholder,
  addDefaultPanels,
  removeStyleManagerOnComponentDeSelect,
  ensureBodyHasBottomSpace,
  removePluginBackgroundColorProperty,
  addCustomAttributeBtn,
  addCustomTraitFromAttribute,
  addTemplateBg,
  // addExternalScripts,
} from "./geditor/grapesjs_settings.js";
import {
  hideLoader,
  removeCommentsFromCss,
  showLoader,
} from "../../helpers/utils.js";
import customPopup from "./geditor/custom-popup/index.js";
import { setDrawnLinkComponentNotDraggable } from "./geditor/add_link/add_link_component.js";

const GrapesJS = ({
  template,
  tId,
  presentation,
  keyMessage,
  pId,
  kmId,
  pathName,
  pathForGoingBack,
  topNavProps,
}) => {
  const [msg, setMsg] = useState(null);
  const [error, setError] = useState(false);

  const keyMessageOrTemplate = keyMessage || template;

  const userStore = useSelector((state) => state.userStore);
  const { config } = userStore;

  let draggingMode =
    config["DRAG_MODE"] === "translate" ? "translate" : "absolute";

  useEffect(() => {
    if (msg) {
      const timeout = setTimeout(() => {
        setMsg(null);
        setError(false);
      }, 5000);

      return () => clearTimeout(timeout);
    }
  }, [msg]);

  useEffect(() => {
    showLoader();
  }, []);

  const onEditorReady = (editor) => {
    (async () => {
      //Added for opening Template html in another tab starts
      if (presentation) {
        //panels.defaults[1].buttons.splice(11, 1);
        const panelManager = editor.Panels;
        panelManager.removeButton("editor-actions", "viewTemplate");
      }
      //Added for opening Template html in another tab ends
      if (!presentation) {
        const panelManager = editor.Panels;
        panelManager.removeButton("editor-actions", "saveThumbImage");
      }
      addEditorCommand(
        editor,
        pathName,
        setMsg,
        setError,
        presentation,
        keyMessageOrTemplate,
        config
      );
      //console.log(editor.Commands);
      // if(
      //   !template &&
      //   keyMessage &&
      //   presentation.platform !== "OCE"
      // ) {
      //   addAdaptiveScript(editor, presentation, kmId);
      // }
      setDrawnLinkComponentNotDraggable(editor);
      previewHandler(editor);
      // preserveComponentTypes(editor)
      // preserveComponentNames(editor)
      // addSelectRemoveStyleOption(editor);
      addPseudoSelectors(editor);
      // addHeaders(editor)
      // addHR(editor)
      ensureBodyHasBottomSpace(editor);
      richTextEditor(editor);
      makeRowsCellsResizable(editor);
      updateFontFamily(editor, pathName, setMsg, setError);
      addDeviceManagerPanels(editor, config["DEVICES"]);
      openVideoManagerOnAddingVideo(editor);
      // addVeevaExternalLink(editor)
      closeAssetManagerOnAssetSelect(editor, pathName, presentation);
      // addModalTriggerElement(editor)
      addPosterTrait(editor, pathName);
      // addWrapperBlock(editor)
      handleAssetDelete(editor, pathName, setMsg, setError, presentation);
      showAlertOnError(editor, setMsg, setError);
      customComponents(editor);
      handleHamburgerClick(editor);
      removePluginBackgroundColorProperty(editor);
      // closeAllCategoriesByDefault(editor);
      enableDraggingFormElements(editor);
      await addTemplates(
        editor,
        config,
        pathName,
        setMsg,
        setError,
        presentation
      );
      autoCloseCategories(editor);
      linkAdjust(editor);
      hideToolbarOnStyleClick(editor);
      addCustomTraitFromAttribute(editor);
      // avoidMultipleWrapper(editor,setMsg, setError);
      addSelectRemoveStyleOption(editor); // called for new style tags

      addTemplateBg(editor, config, pathName);

      await addComponents({
        editor,
        pathName,
        pId,
        kmId,
        setMsg,
        setError,
        userStore,
      });

      await addMCTSJs(editor, pathName, pId, kmId, keyMessage);

      // Load assets from database
      await loadAssetsFromDB(
        editor,
        pathName,
        keyMessageOrTemplate,
        presentation
      );

      // Resize(editor);
      closeAllCategoriesByDefault(editor);

      editor.clearDirtyCount();
      editor.UndoManager.clear();

      window.editor = editor;

      hideLoader();
    })();
  };

  return (
    <>
      {msg && <ToastAlert msg={msg} error={error} />}
      <GjsEditor
        grapesjs="https://unpkg.com/grapesjs@0.21.7/dist/grapes.min.js"
        waitReady
        options={{
          multipleSelection: false,
          forceClass: false,
          exportWrapper: true,
          blockManager: {
            custom: true,
          },
          dragMode: draggingMode,
          allowScripts: 1,
          selectorManager: selectorManager,
          styleManager: styleManager(pathName),
          layerManager: layerManager,
          traitManager: traitManager,
          deviceManager: {
            devices: config["DEVICES"],
            default: presentation?.targettedDevice || "Default",
          },
          projectData: {
            pages: [
              {
                component: `
                    ${keyMessageOrTemplate.content?.["mycustom-html"] || ""}
                    <style>${
                      keyMessageOrTemplate?.content?.["mycustom-css"]
                        ? removeCommentsFromCss(
                            keyMessageOrTemplate?.content?.["mycustom-css"]
                          )
                        : ""
                    }</style>
                  `,
                //   component: `
                //       <div class="test">Loading, Please wait</div>
                //       <style>.test { color: red }</style>
                //     `,
              },
            ],
          },
          assetManager: {
            upload: true,
            embedAsBase64: false,
            autoAdd: 1,
            dropzone: 0, // Enable an upload  dropzone on the entire editor (not  document) when dragging files over it
            openAssetsOnDrop: 1,
            multiUpload: true,
            uploadName: "image",
            uploadFile: (e) => {
              uploadAssets(
                e,
                window.editor,
                pathName,
                setMsg,
                setError,
                presentation
              );
            },
          },
          storageManager: storageSetting(kmId || tId, pathName),
          canvas: {
            styles: template
              ? styles
              : getExternalStyles(
                  pathName,
                  presentation,
                  keyMessage,
                  kmId,
                  styles
                ),
            scripts: scripts,
            frameStyle: bootstrapDefaultStyles,
          },
          plugins: [
            addDefaultPanels,
            preserveComponentNames,
            Resize,
            toggleAbsoluteDragMode,
            addDiv,
            addWrapperBlock,
            gjsBlockBasic,
            gjsForms,
            // gjsTabs,
            gjsRulers,
            dataListTypePlugin,
            grapesjsStyleBg,
            gjsCssParser,
            swiperComponent,
            addHeaders,
            addHR,
            removeStyleManagerOnComponentDeSelect,
            addVeevaExternalLink,
            addVAEemail,
            // addModalTriggerElement,
            // preserveComponentTypes,
            // preserveComponentNames,
            removeBackgroundInputForBody,
            showUnsavedChangesNum,
            customPopup,
            addDocLink,
            moveComponentsByKeys,
            gjsStyleGradient,
            removeGjsSelectedClass,
            addComponentModel,
            avoidMultipleWrapper,
            addNthchildSelector,
            addSelectRemoveStyleOption, // called for pre existing select tags
            removeTextDefaultPadding,
            addCustomVeevaLink,
            addTabComponent,
            addCarouselComponent,
            addIScroll,
            addMultiCarousel,
            addPlaceholder,
            addCustomAttributeBtn,
            // addLinkComponent,
            // scrollComponent,
          ],
          pluginsOpts: {
            [addDefaultPanels]: {
              pathName: pathName,
            },
            [gjsBlockBasic]: { flexGrid: true },
            [gjsForms]: {},
            [swiperComponent]: {},
            // [scrollComponent]: {},
            // [gjsTabs]: {
            //   tabsBlock: {
            //     category: "Extra",
            //   },
            // },
            [gjsRulers]: {
              rulerOpts: {
                // default ------
                // rulerHeight: 15,
                // fontFamily: 'arial',
                // fontSize: '8px',
                // strokeStyle: 'gray',
                // sides: ['top', 'left'],
                // cornerSides: ['TL'],
                // lineWidth: 1,
                // enableMouseTracking: true,
                // enableToolTip: true
                strokeStyle: "black",
                fillStyle: "black",
                fontSize: "10px",
              },
            },
            [dataListTypePlugin]: {},
            [grapesjsStyleBg]: {
              propExtender: grapesJsStyleBGPluginOpts,
            },
            // [customPopup]: {},
            [gjsCssParser]: {},
            [gjsImageEditor]: {
              script: [
                "https://cdnjs.cloudflare.com/ajax/libs/fabric.js/1.6.7/fabric.min.js",
                "https://uicdn.toast.com/tui.code-snippet/v1.5.2/tui-code-snippet.min.js",
                "https://uicdn.toast.com/tui-color-picker/v2.2.7/tui-color-picker.min.js",
                "https://uicdn.toast.com/tui-image-editor/v3.15.2/tui-image-editor.min.js",
              ],
              style: [
                "https://uicdn.toast.com/tui-color-picker/v2.2.7/tui-color-picker.min.css",
                "https://uicdn.toast.com/tui-image-editor/v3.15.2/tui-image-editor.min.css",
              ],
            },
            [gjsStyleGradient]: {},
            [addComponentModel]: {
              pathName,
              pId,
              kmId,
              setMsg,
              setError,
              userStore,
            },
            [avoidMultipleWrapper]: { setMsg, setError },
            [removeTextDefaultPadding]: { config },
            [addCustomVeevaLink]: { config },
          },
        }}
        onReady={onEditorReady}
      >
        <div id="navbar" className="sidenav d-flex flex-column position-fixed">
          <nav className="navbar navbar-light my-1">
            <div className="container-fluid d-flex flex-column">
              <div className="text-center w-100">
                <Link reloadDocument to={pathForGoingBack}>
                  <div className="navbar-brand mb-1 h3" />
                </Link>
              </div>
              <Link reloadDocument to={pathForGoingBack}>
                <p
                  className="mt-1 text-center w-100 text-info"
                  id="page-name"
                  title={keyMessageOrTemplate?.name}
                >
                  <i className="fa fa-step-backward" aria-hidden="true"></i>{" "}
                  {keyMessageOrTemplate?.name}
                </p>
              </Link>
              <div id="panel-util-actions" />
            </div>
          </nav>
          <LeftSidebar />
        </div>
        <div
          className="main-content position-relative w-70 start-15"
          id="main-content"
        >
          {config.AI_ASSISTANT ? (
            <WithEditor>
              <AiAssistantWithEditor />
            </WithEditor>
          ) : null}

          <TopNav {...topNavProps} />
          <div id="gjs-editor">
            <Canvas />
          </div>
          <div id="upload-font"></div>
          <div id="code-editor"></div>
          <div id="upload-video"></div>
          <div id="upload-doc"></div>
          <div id="manage-comp"></div>
          <div id="select-link"></div>
          <div id="drag-mode"></div>
          <div id="nth-child-select"></div>
          <div id="add-custom-attributes"></div>
        </div>
        <div
          id="right-sidenav"
          className="right-sidenav d-flex flex-column position-fixed"
        >
          <RightSidebar />
        </div>
      </GjsEditor>
    </>
  );
};

export default GrapesJS;
